module.exports = __webpack_public_path__ + "img/mountain-min.365f0f34.jpg";